import { i18nTranslate } from 'common/helper/i18n/translate';
import { timeGetDiff } from 'common/helper/time/get-diff';

/* Copying logic present here pf-website/src/Website/Twig/TimeDiffExtension.php */
const COUNT_THRESHOLD = 6;

export function propertyGetElapsedTime(date: string): string {
  const { years, months, days, hours, minutes, seconds } = timeGetDiff(new Date(), new Date(date));

  if (years || months >= COUNT_THRESHOLD) {
    return i18nTranslate('more than 6 month ago');
  }
  if (months) {
    return i18nTranslate('time.ago.month', months).replace('%count%', `${months}`);
  }
  if (days) {
    return i18nTranslate('time.ago.day', days).replace('%count%', `${days}`);
  }
  if (hours) {
    return i18nTranslate('time.ago.hour', hours).replace('%count%', `${hours}`);
  }
  if (minutes) {
    return i18nTranslate('time.ago.minute', minutes).replace('%count%', `${minutes}`);
  }
  if (seconds) {
    return i18nTranslate('time.ago.second', seconds).replace('%count%', `${seconds}`);
  }
}
